import Vue from "vue";
import VueI18n from 'vue-i18n'
import merge from 'deepmerge'

import adminMessages from '../modules/admin/i18n/messages'
import menuMessages from '../menu-config/menu-i18n'
import { i18nMessages as i18nMessagesCommon } from '@dracul/common-frontend'
import { i18nMessages as i18nMessagesUser } from '@dracul/user-frontend'
import { i18nMessages as i18nMessagesCustom } from '@dracul/customize-frontend'
import { i18nMessages as i18nMessagesNotification } from '@dracul/notification-frontend'

const baseMessages = {
    en: {
        base: {
            home: 'Home',
            enter: 'Enter'
        },
        common: {
            noData: 'No data available',
            loading: 'Loading...',
            actions: 'Actions',
            active: 'Active',
            inactive: 'Inactive',
            created: 'Created successfully',
            updated: 'Updated successfully',
            deleted: 'Deleted successfully'
        }
    },
    es: {
        base: {
            home: 'Inicio',
            enter: 'Ingresar'
        },
        common: {
            noData: 'No hay datos disponibles',
            loading: 'Cargando...',
            actions: 'Acciones',
            active: 'Activo',
            inactive: 'Inactivo',
            created: 'Creado exitosamente',
            updated: 'Actualizado exitosamente',
            deleted: 'Eliminado exitosamente'
        }
    }
}

const messages = merge.all([
    baseMessages,
    adminMessages,
    menuMessages,
    i18nMessagesCommon,
    i18nMessagesUser,
    i18nMessagesCustom,
    i18nMessagesNotification
])

Vue.use(VueI18n)

const i18n = new VueI18n({
    locale: 'en',
    messages,
})

export default i18n

